import React, { forwardRef } from "react";
import { Item } from './styles';
export const OptionItem = forwardRef(({ align, children, dividerColor = 'light', handleClick, hasBorderRadius, hasDivider, hasFirstDivider, size = 'regular' }, ref) => {
    return (React.createElement(Item, { ref: ref, align: align, dividerColor: dividerColor, hasBorderRadius: hasBorderRadius, hasDivider: hasDivider, hasFirstDivider: hasFirstDivider, onClick: handleClick, size: size }, children));
});
//# sourceMappingURL=OptionItem.js.map